module.exports = __webpack_public_path__ + "static/img/mirrorImg3.ebd650c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mirrorImg3.png
// module id = PhtG
// module chunks = 2